const meteringHelper = {
    obtenerCookieSuscriptor: function (apiUrl, token, config) {
        var deleteMeteringCookie = function (config) {
            for (let [, value] of Object.entries(config.CookiesMetering)) {
                deleteCookieName(value);
            }
        };

        var deleteCookieName = function (name) {
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/" + (document.domain === 'localhost' ? "" : "; domain=" + config.dominioCookie);
        };

        var createCookie = function (name, value, seconds, domain) {
            var expires = "";
            if (seconds) {
                var date = new Date();
                date.setTime(date.getTime() + (seconds * 1000));
                expires = "; expires=" + date.toGMTString();
            }
            var cookieDomain = (document.domain === 'localhost' ? "" : "; domain=" + domain);
            document.cookie = name + "=" + value + expires + cookieDomain + "; path=/";
        };

        var readCookie = function (name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        };

        var productosPremium = readCookie("ProductoPremiumId");
        var cookieMtrng = readCookie(config.CookiesMetering["metering"]);
        var cookieMtrngSubscribed = false;
        if (cookieMtrng) {
            let arr = cookieMtrng.split('.');
            if (arr && arr.length > 0) {
                let e = arr[0].replace("entitlement=", "");
                console.log({ entitlement: e });
                cookieMtrngSubscribed = e && e.toLocaleUpperCase() == "SUBSCRIBED";
            }
        }
        var esPremium = productosPremium ? productosPremium.split(',').includes('2') : false;
        if (esPremium || (cookieMtrngSubscribed && !esPremium)) {
            deleteMeteringCookie(config);
        }
        deleteCookieName(config.CookiesMetering["serviceDown"]);
        deleteCookieName("metering_arc_ERROR");

        return fetch(apiUrl, {
            method: 'GET',
            headers: { 'X-Token': token || '' }
        }).
            then(response => {
                if (response.status === 200) {
                    return response.text();
                }
                if (response.status === 500) {
                    createCookie(config.CookiesMetering["serviceDown"], true, 600, config.dominioCookie);
                    createCookie('metering_arc_ERROR', "response.status: 500 - " + ((response && response.statusText) ? response.statusText : ""), 600, config.dominioCookie);
                }
                return null;
            }).
            then(data => {
                if (data) {
                    createCookie(config.CookiesMetering["metering"], data, config.cookieExpirationTime, config.dominioCookie);
                }
            }).
            catch((error) => {
                console.error('Error:', error);
                createCookie(config.CookiesMetering["serviceDown"], true, 600, config.dominioCookie);
                createCookie('metering_arc_ERROR', error, 600, config.dominioCookie);
            });
    }
};

export default meteringHelper;


// WEBPACK FOOTER //
// ./Statics/scripts/common/helpers/metering-api-fetch.js